const VALID_ADDRESS_TYPES = [
  "POBOX",
  "Unknown",
  "Delivery",
  "Billing",
  "STREET",
];

const getPostcode = (addresses) =>
  addresses.find((address) => VALID_ADDRESS_TYPES.includes(address.AddressType))
    ?.PostalCode;

const getCountryCode = (addresses) =>
  addresses.find((address) => VALID_ADDRESS_TYPES.includes(address.AddressType))
    ?.Country;

const getAddressLine = (addresses, addressProperty) => {
  const matchedAddress = addresses.find((address) =>
    VALID_ADDRESS_TYPES.includes(address.AddressType),
  );
  if (!matchedAddress) return;

  if (addressProperty) return matchedAddress[addressProperty];

  const addressString = [
    "AddressLine1",
    "AddressLine2",
    "AddressLine3",
    "AddressLine4",
    "City",
    "Region",
    "PostalCode",
    "Country",
  ]
    .map((field) => matchedAddress[field] || "")
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  return addressString || undefined;
};

export { getAddressLine, getPostcode, getCountryCode };
